
export const solutions = {
  '1gb.solutions': 'Soluciones 1Gb',
  '10gb.solutions': 'Soluciones 10Gb',
  '1gb.vpx.accessories': 'Accesorios VPX 1Gb',
  'software': 'Software',
  '1gb.description': 'Soluciones AV sobre IP de alto rendimiento 1Gb',
  '10gb.description': 'Soluciones AV sobre IP de ultra alto rendimiento 10Gb',
  'vpx.accessories.description': 'Accesorios esenciales para soluciones VPX 1Gb',
  'software.description': 'El software Aurora IPBaseT Manager es una aplicación de control todo en uno para los productos IPX, VPX y VLX de Aurora IPBaseT AV sobre IP',
  'avoip.solutions': 'Soluciones AVOIP',
  'choose.network.speed': 'Elija su velocidad de red preferida',
  'touch.controllers': 'Controladores táctiles',
  'touch.controllers.description': 'Interfaces de panel táctil profesionales para un control perfecto',
  'control.processors': 'Procesadores de control',
  'control.processors.description': 'Procesadores de control avanzados para la gestión del sistema',
  'reax.software': 'Software',
  'reax.software.description': 'Software de desarrollo de sistemas de control profesional',
  'reax.accessories': 'Accesorios',
  'reax.accessories.description': 'Accesorios esenciales para sistemas ReAX',
  'reax.control.solutions': 'Soluciones de control ReAX',
  'choose.control.solution': 'Elija su solución de control preferida',
  'digital.signal.processors': 'Procesadores de señal digital',
  'dsps.description': 'Soluciones profesionales de procesamiento de audio',
  'amplifiers': 'Amplificadores',
  'amplifiers.description': 'Amplificación de audio de alto rendimiento',
  'speakers': 'Altavoces',
  'speakers.description': 'Soluciones de reproducción de audio premium',
  'audio.solutions': 'Soluciones de audio',
  'choose.audio.solution': 'Elija su solución de audio preferida',
};
